import { Method as apiMethod } from 'axios'

export const noteEndpoints = {
  fetchNotes: {
    method: 'get' as apiMethod,
    url: '/note/page'
  },
  createNote: {
    method: 'post' as apiMethod,
    url: '/note/'
  }
}
